export const iconFontAwesomeShapesLinesLeaning = (
	<i className="fa-solid fa-lines-leaning"></i>
);
